import axios from "axios";
import refreshToken from "./refreshToken";

const privateAPI = axios.create({
  baseURL: "https://backend.newbrindha.com"
});

privateAPI.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem("access_token");
    
    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`;
    } else {
      console.log("No access token found in localStorage");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

privateAPI.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      console.log("Received 401 error, attempting to refresh token");
      originalRequest._retry = true; 
      
      try {
        const newToken = await refreshToken();
        
        if (newToken) {
          console.log("Token refreshed successfully");
          
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          
          return axios(originalRequest);
        } else {
          console.error("Failed to get new token");
          window.location.href = "/loginprivate"; 
          return Promise.reject(error);
        }
      } catch (refreshError) {
        //console.error("Token refresh failed:", refreshError);
        window.location.href = "/loginprivate"; 
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default privateAPI;